module.exports = __webpack_public_path__ + "img/GAME_PAINTBALL1.74ecb305.jpg";